module.exports = __webpack_public_path__ + "static/media/favebiz-campaign.87c21f4e.png";